import React, { useEffect, useState } from 'react';
import '../../shop/styles/purchaseModal.css';
import '../styles/luckySpin.css';
import ModalBackground from '../../../shared/components/ModalBackground';
import PurchaseActions from '../../../shared/components/PurchaseActions';
import { useTranslation } from 'react-i18next';
import { entityText } from '../../../i18n/entityText';

const MIN_QTY = 1;
const MAX_QTY = 99;

export default function BoostModal({ onClose, item }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => { setVisible(true); }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  const unitPrice = item?.usdt ? parseFloat(item.usdt) : null;
  const totalPrice = unitPrice !== null ? (unitPrice * quantity).toFixed(2) : null;
  const hasItem = !!item?.id;

  const decrement = () => setQuantity(q => Math.max(MIN_QTY, q - 1));
  const increment = () => setQuantity(q => Math.min(MAX_QTY, q + 1));

  return (
    <div className="purchase-modal-overlay" onClick={handleClose}>
      <div
        className={`purchase-modal-sheet ${visible ? 'visible' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="purchase-modal-header" style={{ position: 'relative', overflow: 'visible' }}>
          <ModalBackground />
          <h2 className="purchase-modal-title" style={{ position: 'relative', zIndex: 1 }}>{t('spin.boost_your_luck', 'Boost your luck')}</h2>
          <img className="purchase-modal-close" src="/close.png" alt="close" onClick={handleClose} style={{ position: 'absolute', zIndex: 1 }} />
        </div>
        <div style={{ height: 2, background: '#5f5c7c' }} />

        <div style={{ padding: '24px 20px 32px', textAlign: 'center' }}>
          <p className="purchase-modal-desc" style={{ fontSize: 16, marginBottom: 20 }}>
            {t('boost.description', 'Get an increased chance of winning character modules! 60%+')}
          </p>

          {/* Quantity stepper */}
          <div className="boost-qty-row">
            <button
              className="boost-qty-btn"
              onClick={decrement}
              disabled={quantity <= MIN_QTY}
            >
              −
            </button>
            <span className="boost-qty-value">{quantity}</span>
            <button
              className="boost-qty-btn"
              onClick={increment}
              disabled={quantity >= MAX_QTY}
            >
              +
            </button>
          </div>

          {/* Price display */}
          {unitPrice !== null && (
            <div className="boost-price-block">
              {/* eslint-disable-next-line no-template-curly-in-string -- i18next placeholder after a dollar sign */}
              <span className="boost-price-unit">{t('boost.per_ticket', '${{price}} / ticket', { price: unitPrice.toFixed(2) })}</span>
              <span className="boost-price-total">${totalPrice}</span>
            </div>
          )}

          <PurchaseActions
            allowTON={hasItem}
            allowStars={hasItem}
            purchaseType="BOOST"
            itemId={item?.id}
            usdPrice={item?.usdt}
            priceTON={item?.priceTON}
            priceStars={item?.priceStars}
            description={item?.description
              ? entityText(t, 'shop_item', item.id, 'description', item.description)
              : t('spin.boost_your_luck', 'Boost your luck')}
            disabled={!hasItem}
            onClose={handleClose}
            quantity={quantity}
            itemLabel={t('boost.item_label', 'Boost Ticket × {{n}}', { n: quantity })}
          />
          {!hasItem && (
            <p style={{ color: '#5f5c7c', fontSize: 13, marginTop: 12 }}>{t('common.coming_soon', 'Coming soon')}</p>
          )}
        </div>
      </div>
    </div>
  );
}
